import { LanguageContext } from 'context/languageContext';
import { TFunction } from '@/lib/i9s/types';
import { useContext, useState } from 'react';

import styles from './index.module.css';
import { InsuranceCondition } from '@/Components/InformationModals/InsuranceCondition';
import { CustomButton } from '@/Components/CustomButton';
import { TransferAndReturn } from '@/Components/InformationModals/TransferAndReturn';

const getItems = (t: TFunction) => [
  {
    image: '/assets/1.png',
    text: (
      <div className={styles.text}>
        <p>{t('kate')}</p>
      </div>
    ),
    style: { width: 280, letterSpacing: '-0.4px' },
  },
  {
    image: '/assets/2.png',
    text: (
      <div className={styles.text}>
        <p>{t('pete')}</p>
      </div>
    ),
    style: { width: 280, letterSpacing: '-0.4px' },
  },
  {
    image: '/assets/3.png',
    text: (
      <div className={styles.text}>
        <p>{t('2kate')}</p>
      </div>
    ),
    style: { width: 280, letterSpacing: '-0.4px' },
  },
  {
    image: '/assets/4.png',
    text: (
      <div className={styles.text}>
        <p>{t('weekend')}</p>
      </div>
    ),
    style: { width: 290, letterSpacing: '-0.4px' },
    imgWidth: 290,
  },
];

const MainContent = () => {
  const { t } = useContext(LanguageContext);
  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const closeMoreInfo = () => {
    setIsOpenInfo(false);
  };
  return (
    <div className={styles.container}>
      <div className={styles.containerWrapper}>
        <div className={styles.header}>{t('howWork')}</div>
        <div className={styles.itemsWrapper}>
          {getItems(t).map((el, i) => (
            <div key={el.image} className={styles.item} style={el.style}>
              <div className={i ? styles.overlay : ''}>
                <img
                  className={styles.image}
                  src={el.image}
                  width={el.imgWidth ? el.imgWidth : 280}
                  height={208}
                  alt="img"
                ></img>
              </div>
              {el.text}
            </div>
          ))}
        </div>
        <div style={{ marginTop: '12px' }}>
          <CustomButton
            sizeButton="medium"
            typeButton="secondary"
            style={{ minWidth: 106, height: 44 }}
            onClick={() => {
              setIsOpenInfo(true);
            }}
          >
            <div style={{ color: '#000' }}>{t('moreDetails')}</div>
          </CustomButton>
        </div>
      </div>
      <TransferAndReturn isOpen={isOpenInfo} onClose={closeMoreInfo} />
    </div>
  );
};

export default MainContent;
